/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRewardCodeResponse
 */
export interface CreateRewardCodeResponse {
    /**
     * The generated 6-character alphanumeric reward code
     * @type {string}
     * @memberof CreateRewardCodeResponse
     */
    code: string;
    /**
     * The coin mint address
     * @type {string}
     * @memberof CreateRewardCodeResponse
     */
    mint: string;
    /**
     * The reward address (authorized public key)
     * @type {string}
     * @memberof CreateRewardCodeResponse
     */
    rewardAddress: string;
    /**
     * The reward amount
     * @type {number}
     * @memberof CreateRewardCodeResponse
     */
    amount: number;
}

/**
 * Check if a given object implements the CreateRewardCodeResponse interface.
 */
export function instanceOfCreateRewardCodeResponse(value: object): value is CreateRewardCodeResponse {
    let isInstance = true;
    isInstance = isInstance && "code" in value && value["code"] !== undefined;
    isInstance = isInstance && "mint" in value && value["mint"] !== undefined;
    isInstance = isInstance && "rewardAddress" in value && value["rewardAddress"] !== undefined;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;

    return isInstance;
}

export function CreateRewardCodeResponseFromJSON(json: any): CreateRewardCodeResponse {
    return CreateRewardCodeResponseFromJSONTyped(json, false);
}

export function CreateRewardCodeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRewardCodeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'mint': json['mint'],
        'rewardAddress': json['reward_address'],
        'amount': json['amount'],
    };
}

export function CreateRewardCodeResponseToJSON(value?: CreateRewardCodeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'mint': value.mint,
        'reward_address': value.rewardAddress,
        'amount': value.amount,
    };
}

